module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.4-232.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.4.md
// module id = 675
// module chunks = 304